/**
 * EN | ES, in the header of every screen including the PIN pad.
 *
 * Deliberately not hidden behind a settings menu: an operator who cannot read English
 * cannot navigate an English menu to find the language switch. It has to be visible
 * from the first screen they land on.
 *
 * Both labels are always rendered in their own language, so neither reader has to
 * recognise a foreign word to find their own.
 */

import { useI18n, type Language } from '../lib/i18n.tsx';

const OPTIONS: ReadonlyArray<{ readonly language: Language; readonly label: string }> = [
  { language: 'en', label: 'EN' },
  { language: 'es', label: 'ES' },
];

export function LanguageToggle() {
  const { language, setLanguage } = useI18n();

  return (
    <div className="inline-flex overflow-hidden rounded-md border border-line" role="group">
      {OPTIONS.map((option) => {
        const selected = option.language === language;

        return (
          <button
            key={option.language}
            type="button"
            lang={option.language}
            aria-pressed={selected}
            onClick={() => setLanguage(option.language)}
            // 44px minimum even here: this is tapped with a gloved thumb like
            // everything else in the app.
            className={`min-h-11 px-4 text-sm font-semibold ${
              selected ? 'bg-brand text-plane' : 'bg-surface text-ink-secondary'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
